import { Drawer } from "@material-ui/core";
import NavContent from "./NavContent.jsx";
import "./sidebar.scss";

function Sidebar({theme, showPerformance}) {
  return (
    <div className={`sidebar`} id="sidebarContent">
      <Drawer variant="permanent" anchor="left" showPerformance={showPerformance}>
        <NavContent theme={theme} showPerformance={showPerformance} />
      </Drawer>
    </div>
  );
}

export default Sidebar;
